import { TranslationSet } from './en';

// TODO: translate values from English
export const ar: TranslationSet = {
  '(From Now)': '(من الآن)',
  '(From Scheduled)': '(من المقرر)',
  '{amount} Off. Expires: {expires}.': '{amount} معطل. تنتهي الصلاحية: {expires}.',
  'A detailed report showing each activity and how long a technician or staff member took between and at each site with a total time at the site.': 'تقرير مفصل يوضح كل نشاط والمدة التي استغرقها الفني أو الموظف بين وفي كل موقع مع إجمالي الوقت الذي قضاه في الموقع.',
  'A service type with inspection enabled will show up in the "to inspect" list on mobile. It is also used in reporting.': 'سيظهر نوع الخدمة مع تمكين الفحص في قائمة "للفحص" على الهاتف المحمول. كما أنها تستخدم في إعداد التقارير.',
  'Accept Invite': 'قبول الدعوة',
  'Add Condition': 'إضافة شرط',
  'Add deficiencies to the equipment type': 'إضافة أوجه القصور إلى نوع المعدات',
  'Add Deficiency': 'إضافة النقص',
  'Add Equipment Field': 'إضافة مجال المعدات',
  'Add Equipment Type': 'أضف نوع المعدات',
  'Add Equipment': 'أضف المعدات',
  'Add Floor Plan': 'أضف مخطط الطابق',
  'Add history by clicking the plus in the top right or by performing a service.': 'أضف السجل عن طريق النقر فوق علامة الزائد في الج��ء العلوي الأيسر أو عن طريق إجراء خدمة.',
  'Add History': 'أضف التاريخ',
  'Add Model Field': 'إضافة حقل النموذج',
  'Add Model': 'إضافة نموذج',
  'Add Option': 'إضافة خيار',
  'Add Question': 'أضف سؤال',
  'Add questions using the plus icon in the top right': 'أضف أسئلة باستخدام أيقونة علامة الجمع في الجزء العلوي الأيسر',
  'Add service month categories in settings > service month categories. Service months allow you to keep different types of equipment in selected months for each location. Example: Alarms in May and October and Extinguishers in December.': 'أضف فئات شهر الخدمة في الإعدادات> فئات شهر الخدمة. تتيح لك أشهر الخدمة الاحتفاظ بأنواع مختلفة من المعدات في أشهر محددة لكل موقع. مثال: الإنذارات في مايو وأكتوبر وطفايات الحريق في ديسمبر.',
  'Add Service Month Category': 'إضافة فئة شهر الخدمة',
  'Add Service Type': 'أضف نوع الخدمة',
  'Add service types in the settings': 'أضف أنواع الخدمة في الإعدادات',
  'Add service types using the plus icon in the top right': 'أضف أنواع الخدمة باستخدام أيقونة الزائد في أعلى اليمين',
  'Add services to the equipment type': 'إضافة الخدمات إلى نوع المعدات',
  'Add site Field': 'إضافة حقل الموقع',
  'Add Site Override': 'إضافة تجاوز الموقع',
  'Add Site Type': 'أضف نوع الموقع',
  'Add Site': 'أضف موقع',
  'Add Sites': 'أضف مواقع',
  'Add User': 'إضافة مستخدم',
  'Add your own fields in Settings > Custom Fields > Site Fields': 'أضف حقولك الخاصة في الإعدادات > الحقول المخصصة > حقول الموقع',
  'Add': 'أضف',
  'Adding': 'إضافة',
  'Address': 'العنوان',
  'Advance from Now': 'تقدم من الآن',
  'Advance from Scheduled': 'تقدم من المقرر',
  'Agree': 'أوافق',
  'All Sites Scheduled!': 'جميع المواقع مجدولة!',
  'All': 'الكل',
  'Already have an account? Login': 'هل لديك حساب بالفعل؟ تسجيل الدخول',
  'An error happened while syncing': 'حدث خطأ أثناء المزامنة',
  'April': 'أبريل',
  'August': 'أغسطس',
  'Back': 'العودة',
  'Billing Portal': 'بوابة الفواتير',
  'Building Reports': 'تقارير البناء',
  'Cancel Plan': 'إلغاء الخطة',
  'Cancel Subscription': 'إلغاء الاشتراك',
  'Cancel': 'إلغاء',
  'Change Model Fields': 'تغيير حقول النموذج',
  'Change Password': 'تغيير كلمة المرور',
  'Checklist Information': 'معلومات قائمة المراجعة',
  'Checklist Question': 'سؤال قائمة المراجعة',
  'Checklist': 'قائمة التحقق',
  'Choose File': 'اختر ملف',
  'City': 'المدينة',
  'Clear All Data': 'مسح كافة البيانات',
  'Clear': 'واضح',
  'Click or tap to add location': 'انقر أو اضغط لإضافة الموقع',
  'Close': 'إغلاق',
  'Company-Wide Reports': 'التقارير على مستوى الشركة',
  'Conditions': 'الشروط',
  'Contact': 'الاتصال',
  'Copy Barcode': 'نسخ الباركود',
  'Could not access': 'لا يمكن الوصول',
  'Could not find equipment with the scanned barcode': 'تعذر العثور على المعدات التي تحتوي على الباركود الممسوح ضوئيًا',
  'Could Not Service': 'لا يمكن الخدمة',
  'Create': 'إنشاء',
  'Creating Your Account': 'إنشاء حسابك',
  'Credentials are not valid': 'بيانات الاعتماد غير صالحة',
  'CSV': 'CSV',
  'Custom Equipment Fields': 'مجالات المعدات المخصصة',
  'Custom Fields': 'الحقول المخصصة',
  'Custom Model Fields': 'حقول النماذج المخصصة',
  'Custom site Fields': 'حقول الموقع المخصصة',
  'Date': 'التاريخ',
  'Debug': 'تصحيح',
  'December': 'ديسمبر',
  'Deficiencies': 'أوجه القصور',
  'Deficiency Report': 'تقرير النقص',
  'Deficiency': 'نقص',
  'Delete Equipment Field?': 'هل تريد حذف حقل المعدات؟',
  'Delete Equipment Type?': 'هل تريد حذف نوع المعدات؟',
  'Delete Equipment Type': 'حذف نوع المعدات',
  'Delete Equipment?': 'هل تريد حذف المعدات؟',
  'Delete Equipment': 'حذف المعدات',
  'Delete Floor Plan?': 'هل تريد حذف مخطط الطابق؟',
  'Delete Model Field?': 'هل تريد حذف حقل النموذج؟',
  'Delete Model?': 'هل تريد ح��ف النموذج؟',
  'Delete Model': 'حذف النموذج',
  'Delete Override': 'حذف التجاوز',
  'Delete Question?': 'هل تريد حذف السؤال؟',
  'Delete Question': 'حذف السؤال',
  'Delete Record?': 'هل تريد حذف السجل؟',
  'Delete Service Month?': 'هل تريد حذف شهر الخدمة؟',
  'Delete Service Type?': 'هل تريد حذف نوع الخدمة؟',
  'Delete Site Field?': 'هل تريد حذف حقل الموقع؟',
  'Delete Site Type?': 'هل تريد حذف نوع الموقع؟',
  'Delete Site?': 'هل تريد حذف الموقع؟',
  'Delete Site': 'حذف الموقع',
  'Delete User?': 'هل تريد حذف المستخدم؟',
  'Delete User': 'حذف المستخدم',
  'Delete': 'حذف',
  'Deleted Equipment Field': 'حقل المعدات المحذوفة',
  'Deleted Equipment': 'المعدات المحذوفة',
  'Deleted Floor Plan': 'مخطط الطابق المحذوف',
  'Deleted Model Field': 'حقل النموذج المحذوف',
  'Deleted Record': 'السجل المحذوف',
  'Deleted Service Month': 'شهر الخدمة المحذوفة',
  'Deleted Service Type': 'نوع الخدمة المحذوفة',
  'Deleted Site Field': 'حقل الموقع المحذوف',
  'Deleted Site Type': 'نوع الموقع المحذوف',
  'Detailed': 'مفصلة',
  'Did not want done': 'لا تريد القيام به',
  'Done by others': 'تم من قبل الآخرين',
  'Don\'t have an account? Sign Up': 'ليس لديك حساب؟ قم بالتسجيل',
  'Done': 'تم',
  'Edit Dates': 'تحرير التواريخ',
  'Edit Equipment': 'تحرير المعدات',
  'Edit': 'تحرير',
  'Email is not valid': 'البريد الإلكتروني غير صالح',
  'End Date': 'تاريخ الانتهاء',
  'Enter your email address': 'أدخل عنوان بريدك الإلكتروني',
  'Equipment already has this barcode': 'تحتوي المعدات بالفعل على هذا الرمز الشريطي',
  'Equipment can be anything from a fire extinguisher to a treadmill. Set up equipment types in settings > equipment types.': 'المعدات يمكن أن تكون أي شيء من طفاية حريق إلى حلقة مفرغة. قم بإعداد أنواع المعدات في الإعدادات > أنواع المعدات',
  'Equipment Deleted': 'تم حذف المعدات',
  'Equipment Due Consolidated Report': 'التقرير الموحد المستحق للمعدات',
  'Equipment Due Report': 'تقرير استحقاق المعدات',
  'Equipment Field Information': 'معلومات مجال المعدات',
  'Equipment fields allow you to add different additional fields on the equipment type, such as "Voltage" or "Km".': 'تتيح لك حقول المعدات إضافة حقول إضافية مختلفة على نوع المعدة، مثل "الجهد" أو "كم".',
  'Equipment Fields': 'مجالات المعدات',
  'Equipment for a site with all scheduled services.': 'المعدات اللازمة للموقع مع جميع الخدمات المجدولة.',
  'Equipment Options': 'خيارات المعدات',
  'Equipment Report': 'تقرير المعدات',
  'Equipment Service Report': 'تقرير خدمة المعدات',
  'Equipment SKU': 'رمز SKU للمعدات',
  'Equipment Type Deleted': 'تم حذف نوع الجهاز',
  'Equipment Type': 'نوع المعدات',
  'Equipment types quickly add inspection and service definitions to equipment when a model containing it is selected. Examples: Fire Extinguisher, Treadmill, Truck': 'تقوم أنواع المعدات بإضافة تعريفات الفحص والخدمة إلى المعدات بسرعة عند تحديد نموذج يحتوي عليها. أمثلة: طفاية حريق، جهاز المشي، الشاحنة',
  'Equipment Types': 'أنواع المعدات',
  'Equipment': 'المعدات',
  'Export Billing Data': 'تصدير بيانات الفواتير',
  'Export Data': 'تصدير البيانات',
  'Export': 'تصدير',
  'Failed to load organization.': 'فشل تحميل المؤسسة.',
  'Failed to save the organization.': 'فشل في حفظ المؤسسة.',
  'February': 'فبراير',
  'Fill out the options below to prepare your report.': 'قم بملء الخيارات أدناه لإعداد تقريرك.',
  'Filter By': 'تصفية حسب',
  'FlameTask Basic Subscription': 'اشتراك FlameTask الأساسي',
  'FlameTask Enterprise Subscription': 'اشتراك مؤسسة FlameTask',
  'FlameTask Pro Subscription': 'اشتراك FlameTask Pro',
  'Floor Plan Location': '��وقع مخطط الطابق',
  'Floor Plan': 'خطة الكلمة',
  'Floor Plans': 'خطط الكلمة',
  'Force Error': 'خطأ في القوة',
  'Forgot Password': 'نسيت كلمة المرور',
  'Generate': 'إنشاء',
  'Hide "added" history records': 'إخفاء سجلات التاريخ "المضافة".',
  'Hide Advanced': 'إخفاء المتقدم',
  'History': 'التاريخ',
  'How long a user spent at a site with time between actions.': 'المدة التي قضاها المستخدم في الموقع مع مرور الوقت بين الإجراءات.',
  'If this email matched an account, a link was sent to reset your password.': 'إذا كان هذا البريد الإلكتروني يطابق أحد الحسابات، فسيتم إرسال رابط لإعادة تعيين كلمة المرور الخاصة بك.',
  'Import Data': 'استيراد البيانات',
  'Import': 'استيراد',
  'Inspection Due': 'التفتيش المستحق',
  'Inspection Report': 'تقرير التفتيش',
  'Inspection': 'التفتيش',
  'Inspections are up to date': 'عمليات التفتيش محدثة',
  'January': 'يناير',
  'July': 'يوليو',
  'June': 'يونيو',
  'Leave': 'غادر',
  'List of all equipment at the site with options to show services and filtering based on due service and/or inspection.': 'قائمة بجميع المعدات الموجودة في الموقع مع خيارات لإظهار الخدمات والتصفية بناءً على الخدمة الواجبة و/أو الفحص.',
  'List of all sites with their information. Options to filter by status and service month to find which sites are serviced in a specific month.': 'قائمة بجميع المواقع مع معلوماتها. خيارات للتصفية حسب الحالة وشهر الخدمة للعثور على المواقع التي تتم خدمتها في شهر محدد.',
  'List of equipment and deficiencies at the site, filtered by equipment with deficiencies that have a date opened and no closed date.': 'قائمة ا��معدات والنواقص في الموقع، مفلترة حسب المعدات ذات النواقص التي لها تاريخ فتح وليس لها تاريخ إغلاق.',
  'List of equipment between a range of dates with answers to the questions asked when performing a service or inspection.': 'قائمة المعدات بين مجموعة من التواريخ مع إجابات للأسئلة المطروحة عند إجراء الخدمة أو الفحص.',
  'List of Equipment for a site with important information such as last inspection date and next due service, highlighting equipment due for inspection in red.': 'قائمة المعدات الخاصة بموقع ما تحتوي على معلومات مهمة مثل تاريخ آخر فحص والخدمة التالية المستحقة، مع تسليط الضوء على المعدات المستحقة للفحص باللون الأحمر.',
  'List of equipment that fits model search criteria. Example: a list of 5 pieces of equipment with model information matching 6LB ABC DRY.': 'قائمة المعدات التي تناسب معايير البحث النموذجية. مثال: قائمة مكونة من 5 قطع من المعدات مع معلومات الطراز المطابقة لـ 6LB ABC DRY.',
  'Loading Equipment': 'معدات التحميل',
  'Loading Models...': 'جارٍ تحميل النماذج...',
  'Loading Scheduled Services...': 'جارٍ تحميل الخدما�� المجدولة...',
  'Loading Scheduled Sites': 'تحميل المواقع المجدولة',
  'Loading Service Types...': 'جارٍ تحميل أنواع الخدمات...',
  'Loading Sites': 'تحميل المواقع',
  'Loading Unscheduled Services...': 'جارٍ تحميل الخدمات غير المجدولة...',
  'Loading...': 'جار التحميل...',
  'Location': 'الموقع',
  'Logging in...': 'تسجيل الدخول...',
  'Login Failed': 'فشل تسجيل الدخول',
  'Login': 'تسجيل الدخول',
  'Logout': 'تسجيل الخروج',
  'March': 'مارس',
  'May': 'مايو',
  'Meter Based Condition': 'حالة تعتمد على العداد',
  'Model Deleted': 'تم حذف النموذج',
  'Model Field Information': 'المعلومات الميدانية النموذجية',
  'Model fields allow you to describe and report on equipment such as "Size", "Type" and "Category".': 'تسمح لك حقول النموذج بوصف المعدات والإبلاغ عنها مثل "الحجم" و"النوع" و"الفئة".',
  'Model Fields': 'الحقول النموذجية',
  'Model Information': 'معلومات النموذج',
  'Model Name': 'اسم النموذج',
  'Models allow quickly adding information to equipment such as which equipment type/services belong to it.': 'تسمح النماذج بإضافة معلومات بسرعة إلى المعدات، مثل نوع المعدات/الخدمات التي تنتمي إليها.',
  'Models': 'نماذج',
  'Months of History (to start of month)': 'أشهر التاريخ (لبداية الشهر)',
  'More Details': 'مزيد من التفاصيل',
  'Name': 'الاسم',
  'Nevermind': 'لا يهم',
  'No Custom Equipment Fields': 'لا توجد حقول معدات مخصصة',
  'No Deficiencies': 'لا أوجه القصور',
  'No Equipment Fields': 'لا توجد حقول المعدات',
  'No Equipment Types': 'لا توجد أنواع المعدات',
  'No Equipment': 'لا المعدات',
  'No Floor Plans': 'لا توجد خطط الكلمة',
  'No History': 'لا يوجد تاريخ',
  'No Model Fields': 'لا توجد حقول نموذجية',
  'No Models': 'لا نماذج',
  'No Open Deficiencies': 'لا توجد أوجه قصور مفتوحة',
  'No Open or Closed Issues': 'لا توجد قضايا مفتوحة أو مغلقة',
  'No overrides for this Site': 'لا توجد تجاوزات لهذا الموقع',
  'No Questions': 'لا أسئلة',
  'No Scheduled Services': 'لا توجد خدمات مجدولة',
  'No Scheduled Sites': 'لا توجد مواقع مجدولة',
  'No Service Month Categories': 'لا توجد فئات شهر الخدمة',
  'No Service Types': 'لا توجد أنواع الخدمة',
  'No Site Fields': 'لا توجد حقول الموقع',
  'No Site Types': 'لا توجد أنواع المواقع',
  'No Sites': 'لا توجد مواقع',
  'No Unscheduled Services': 'لا توجد خدمات غير مجدولة',
  'No, Go Back': 'لا، العودة',
  'No': 'لا',
  'Not in at the time of inspection': 'ليس في وقت التفتيش',
  'Nothing to Inspect': 'لا شيء للتفتيش',
  'Nothing to Service': 'لا شيء للخدمة',
  'November': 'نوفمبر',
  'October': 'أكتوبر',
  'Ok': 'حسنًا',
  'Open a deficiency by clicking the plus in the top right of the pane. When the issue has been resolved, click on it and set the closed date.': 'افتح النقص بالنقر فوق علامة الزائد الموجودة في الجزء العلوي الأيسر من الجزء. عندما يتم حل المشكلة، اضغط عليها وحدد تاريخ الإغلاق.',
  'Open a deficiency by tapping Options > Add Deficiency': 'افتح النقص من خلال النقر على الخيارات > إضافة النقص',
  'Open Deficiencies': 'النقائص المفتوحة',
  'Open Deficiency': 'النقص المفتوح',
  'Open in Apple Maps': 'افتح في خرائط أبل',
  'Open in Google Maps': 'افتح في خرائط جوجل',
  'Open Settings': 'افتح الإعدادات',
  'Open': 'مفتوح',
  'Optional: Add a deficiency if this option is selected.': 'اختياري: قم بإضافة النقص إذا تم تحديد هذا الخيار.',
  'Optional: This can be useful to set meter values easily': 'اختياري: قد يكون هذا مفيدًا لتعيين قيم جهاز القياس بسهولة',
  'Organization': 'التنظيم',
  'Outstanding Equipment': 'المعدات المتميزة',
  'PDF': 'قوات الدفاع الشعبي',
  'Perform From Now': 'تنفيذ من الآن',
  'Perform From Scheduled': 'تنفيذ من المقرر',
  'Perform Service From Scheduled': 'أداء الخدمة من المقرر',
  'Perform Service': 'أداء الخدمة',
  'Perform': 'أداء',
  'Phone Number': 'رقم الهاتف',
  'Please fill out all fields': 'يرجى ملء كافة الحقول',
  'Please give a reason': 'يرجى إعطاء السبب',
  'Please select country first': 'الرجاء تحديد البلد أولا',
  'Popup Note': 'ملاحظة منبثقة',
  'Preferences': 'التفضيلات',
  'Preview Details': 'تفاصيل المعاينة',
  'Profile': 'الملف الشخصي',
  'Purchase Barcodes': 'شراء الباركود',
  'Question Deleted': 'تم حذف السؤال',
  'Question Information': 'معلومات السؤال',
  'Questionnaire Report': 'تقرير الاستبيان',
  'Questions': 'أسئلة',
  'Range End': 'نهاية المدى',
  'Range Start': 'بداية النطاق',
  'Reactivate': 'إعادة التنشيط',
  'Remove': 'إزالة',
  'Replace Barcode': 'استبدال الباركود',
  'Replace Equipment': 'استبدال المعدات',
  'Replaced equipment': 'المعدات المستبدلة',
  'Report Date': 'تاريخ التقرير',
  'Reports': 'التقارير',
  'Save time and minimize risk by plotting the location of equipment on a floor plan of this site': 'يمكنك توفير الوقت وتقليل المخاطر عن طريق رسم موقع المعدات على مخطط أرضي لهذا الموقع',
  'Save': 'حفظ',
  'Saving': 'الادخار',
  'Scan barcode to make changes': 'مسح الباركود لإجراء التغييرات',
  'Scan Barcode': 'مسح الباركود',
  'Scan': 'مسح',
  'Schedule': 'الجدول الزمني',
  'Scheduled Event': 'حدث مجدول',
  'Scheduled service definitions can be added to the equipment type in settings > equipment types': 'يمكن إضافة تعريفات الخدمة المجدولة إلى نوع الجهاز في الإعدادات > أنواع المعدات',
  'Scheduled': 'المقرر',
  'See More': 'شاهد المزيد',
  'Selecting an option will add a history record and remove it from the todo list': 'سيؤدي تحديد خيار إلى إضافة سجل محفوظات وإزالته من قائمة المهام',
  'Selective Equipment Report': 'تقرير المعدات الانتقائية',
  'September': 'سبتمبر',
  'Service Due': 'الخدمة مستحقة',
  'Service month categories allow you to keep different types of equipment in different months. For example, you could inspect fire extinguishers in August and May and alarms in October.': 'تتيح لك فئات أشهر الخدمة الاحتفاظ بأنواع مختلفة من المعدات في أشهر مختلفة. على سبيل المثال، يمكنك فحص طفايات الحريق في أغسطس ومايو وأجهزة الإنذار في أكتوبر.',
  'Service Month Categories': 'فئات شهر الخدمة',
  'Service Month Category': 'فئة شهر الخدمة',
  'Service Month': 'شهر الخدمة',
  'Service months allow you to keep different types of equipment in selected months for each site. Example: Alarms in May and October and Extinguishers in December.': 'تتيح لك أشهر الخدمة الاحتفاظ بأنواع مختلفة من المعدات في أشهر محددة لكل موقع. مثال: الإنذارات في مايو وأكتوبر وطفايات الحريق في ديسمبر.',
  'Service Months': 'أشهر الخدمة',
  'Service overrides allow you to disable a service or change the frequency for a specific site': 'تسمح لك تجاوزات الخدمة بتعطيل الخدمة أو تغيير التردد لموقع معين',
  'Service Type Settings': 'إعدادات نوع الخدمة',
  'Service Type': 'نوع الخدمة',
  'Service Types': 'أنواع الخدمة',
  'Service': 'الخدمة',
  'Services are up to date': 'الخدمات محدثة',
  'Services': 'الخدمات',
  'Set answer to equipment field': 'تعيين الإجابة على مجال المعدات',
  'Settings': 'الإعدادات',
  'Show Advanced': 'إظهار المتقدم',
  'Show History Time': 'عرض وقت التاريخ',
  'Show Inspections': 'عرض عمليات التفتيش',
  'Show Questions / Answers': 'عرض الأسئلة / الإجابات',
  'Show Services': 'عرض الخدمات',
  'Sign Up': 'قم بالتسجيل',
  'Simulate Scan': 'محاكاة المسح',
  'Site Deleted': 'تم حذف الموقع',
  'Site Field Information': 'المعلومات الميدانية للموقع',
  'Site fields will allow you to enter additional information into the site, such as "Parking Location".': 'ستسمح لك حقول الموقع بإدخال معلومات إضافية في الموقع، مثل "موقع ركن السيارة".',
  'Site Fields': 'حقول الموقع',
  'Site Information': 'معلومات الموقع',
  'Site Report': 'تقرير الموقع',
  'Site Reports': 'تقارير الموقع',
  'Site Service Override': 'تجاوز خدمة الموقع',
  'Site Service Overrides': 'تجاوزات خدمة الموقع',
  'Site Service Settings': 'إعدادات خدمة الموقع',
  'Site Settings': 'إعدادات الموقع',
  'Site Type': 'نوع الموقع',
  'Site types allow you to change service types based on the site. For example, only monthly customers would show the monthly inspection.': 'تتيح لك أنواع المواقع إمكانية تغيير أنواع الخدمات بناءً على الموقع. على سبيل المثال، سيظهر العملاء الشهريون فقط الفحص الشهري.',
  'Site types allow you to have different service types at different types of sites. For example, you may have to do monthly inspections at one site and only an annual inspection at another.': 'تتيح لك أنواع المواقع الحصول على أنواع خدمات مختلفة في أنواع مختلفة من المواقع. على سبيل المثال، قد يتعين عليك إجراء عمليات فحص شهرية في أحد المواقع وفحص سنوي فقط في موقع آخر.',
  'Site Types': 'أنواع المواقع',
  'Sites can help you organize equipment into places such as "Office" or "Warehouse". If you run a servicing company, you can add your clients as sites. ': 'يمكن أن تساعدك المواقع في تنظيم المعدات في أماكن مثل "المكتب" أو "المستودع". إذا كنت تدير شركة خدمات، فيمكنك إضافة عملائك كمواقع. ',
  'Sites': 'مواقع',
  'Start Date': 'تاريخ البدء',
  'Start Trial': 'ابدأ المحاكمة',
  'Status': 'الحالة',
  'Summary of services at a site separated by model information. Example 5 Monthly Inspections with model information 6LB DRY ABC.': 'ملخص الخدمات في الموقع مفصولة بمعلومات النموذج. مثال 5: عمليات التفتيش الشهرية مع معلومات النموذج 6LB DRY ABC.',
  'Swap Equipment': 'معدات المبادلة',
  'Swapped equipment': 'المعدات المتبادلة',
  'TEST': 'اختبار',
  'The EMS plan is a discounted plan for non-profit or publicly funded emergency services.  Please choose another plan if you do not match this criteria': 'خطة EMS هي خطة مخفضة لخدمات الرعاية الصحية غير الربحية أو الممولة من القطاع العام.  يرجى اختيار خطة أخرى إذا كنت لا تتطابق مع هذه المعايير',
  'The popup note is used to remind you of important information regarding the location. It will appear when opening the location screen.': 'تُستخدم الملاحظة المنبثقة لتذكيرك بالمعلومات المهمة المتعلقة بالموقع. سيظهر عند فتح شاشة الموقع.',
  'There are no unscheduled sites with outstanding inspections, service or deficiencies.': 'لا توجد مواقع غير مجدولة بها عمليات تفتيش أو خدمة أو أوجه قصور معلقة.',
  'There is no equipment at this site with this search criteria and due inspections': 'لا توجد معدات في هذا الموقع بمعايير البحث وعمليات التفتيش الواجبة',
  'There is no equipment at this site with this search criteria and due service': 'لا توجد معدات في هذا الموقع بمعايير البحث والخدمة الواجبة',
  'This Month': 'هذا الشهر',
  'Time at Site Detailed': 'الوقت في الموقع مفصل',
  'Time at Site': 'الوقت في الموقع',
  'Time Based Condition': 'الحالة المستندة إلى الوقت',
  'Today': 'اليوم',
  'Transfer Equipment': 'معدات النقل',
  'Unscheduled service definitions can be added to the equipment type in settings > equipment types': 'يمكن إضافة تعريفات الخدمة غير المجدولة إلى نوع الجهاز في الإعدادات > أنواع المعدات',
  'Unscheduled': 'غير مجدولة',
  'Updated barcode': 'تحديث الباركود',
  'Used Equipment SKU': 'المعدات المستعملة SKU',
  'Used for the billing export for new, swapped and replaced equipment.': 'يُستخدم لتصدير الفواتير للمعدات الجديدة والمستبدلة والمستبدلة.',
  'User Deleted': 'تم حذف المستخدم',
  'User Information': 'معلومات المستخدم',
  'User': 'المستخدم',
  'Users': 'المستخدمين',
  'View on FloorPlan': 'عرض على FloorPlan',
  'View Terms': 'عرض الشروط',
  'Whenever equipment is swapped the billing export will increment the quantitiy under this SKU.': 'عندما يتم تبديل المعدات، ستؤدي عملية تصدير الفواتير إلى زيادة الكمية بموجب SKU هذا.',
  'Yes, Delete Equipment Field': 'نعم، احذف حقل المعدات',
  'Yes, Delete Equipment Type': 'نعم، احذف نوع المعدات',
  'Yes, Delete Equipment': 'نعم، احذف المعدات',
  'Yes, Delete Floor Plan': 'نعم، قم بحذف مخطط الطابق',
  'Yes, Delete Model Field': 'نعم، قم بحذف حقل النموذج',
  'Yes, Delete Model': 'نعم، احذف النموذج',
  'Yes, Delete Question': 'نعم احذف السؤال',
  'Yes, Delete Record': 'نعم، حذف السجل',
  'Yes, Delete Service Month': 'نعم، احذف شهر الخدمة',
  'Yes, Delete Service Type': 'نعم، قم بحذف نوع الخدمة',
  'Yes, Delete Site Field': 'نعم، احذف حقل الموقع',
  'Yes, Delete Site Type': 'نعم، احذف نوع الموقع',
  'Yes, Delete Site': 'نعم، احذف الموقع',
  'Yes, Delete User': 'نعم، احذف المستخدم',
  'Zone': 'المنطقة',
  'Customer': 'العميل',
  'Site': 'الموقع',
  'All Sites': 'جميع المواقع',
  'Loading Customers': 'تحميل العملاء',
  'No Customers': 'لا يوجد عملاء',
  'Add Customer': 'إضافة العميل',
  'Customers are groups of sites with billing information.': 'العملاء عبارة عن مجموعات من المواقع التي تحتوي على معلومات الفوترة.',
  'Customers': 'العملاء',
  'Customer Information': 'معلومات العملاء',
  'Delete Customer': 'حذف العميل',
  'Yes, Delete Customer': 'نعم، قم بحذف العميل',
  'Delete Customer?': 'هل تريد حذف العميل؟',
  'Customer Deleted': 'تم حذف العميل',
  'Create Customer': 'إنشاء عميل',
  'Assign Existing Customer': 'تعيين العميل الحالي',
  'Edit Customer': 'تحرير العميل',
  'Enter a serial number': 'أدخل الرقم التسلسلي',
  'Remove Customer': 'إزالة العميل',
  'Find': 'البحث عن',
  'Sync Now': 'مزامنة الآن',
  'Syncing...': 'جارٍ المزامنة...',
  'Find equipment by serial number': 'البحث عن المعدات عن طريق الرقم التسلسلي',
  'Last successful upload was {formattedDate}': 'آخر تحميل ناجح كان {formattedDate}',
  'Up to date as of {formattedDate}': 'محدث اعتبارًا من {formattedDate}',
  'Zones are used to group locations in the location report': 'تُستخدم المناطق لتجميع المواقع في تقرير الموقع',

  'Account Number': 'رقم الحساب',
  'Add Location Override': 'إضافة تجاوز الموقع',
  'Add New Model': 'إضافة نموذج جديد',
  'Add Site Field': 'إضافة حقل الموقع',
  'Address Line 2': 'سطر العنوان 2',
  'Agree to': 'توافق على',
  'All conditions are true': 'جميع الشروط صحيحة',
  'All Permissions': 'جميع الأذونات',
  'Allow Text Input': 'السماح بإدخال النص',
  'An email with the reset password link below has been sent to': 'تم إرسال بريد إلكتروني يحتوي على رابط إعادة تعيين كلمة المرور أدناه إلى',
  'An error ocurred while trying to show this page.': 'حدث خطأ أثناء محاولة إظهار هذه الصفحة.',
  'Any condition is true': 'أي شرط صحيح',
  'Background Color': 'لون الخلفية',
  'Billing and customer controls': 'ضوابط الفواتير والعملاء',
  'Building Reports - Safety Scan': 'تقارير البناء - مسح السلامة',
  'Change Another Service': 'تغيير خدمة أخرى',
  'Choose Site': 'اختر الموقع',
  'click here': 'انقر هنا',
  'Closed Date': 'تاريخ مغلق',
  'Closed Deficiencies': 'نواقص مغلقة',
  'Company Information': 'معلومات الشركة',
  'Company Name': 'اسم الشركة',
  'Completing Sign Up': 'استكمال التسجيل',
  'Context ID': 'معرف السياق',
  'Could not find equipment with that barcode': 'تعذر العثور على المعدات التي تحتوي على هذا الرمز الشريطي',
  'Creating invite link...': 'جارٍ إنشاء رابط الدعوة...',
  'Current equipment failed to load': 'فشل تحميل المعدات الحالية',
  'Data File': 'ملف البيانات',
  'Data Origin': 'أصل البيانات',
  'Date affected by': 'التاريخ المتأثر',
  'Date Completed': 'تاريخ الانتهاء',
  'Date Started': 'تاريخ البدء',
  'Delete equipment?': 'هل تريد حذف المعدات؟',
  'Dev Environment': 'بيئة التطوير',
  'Disabled For': 'معطل ل',
  'Disabled For Location': 'معطل للموقع',
  'Do not change': 'لا تتغير',
  'Due When': 'موعد الاستحقاق',
  'Edit Deficiencies': 'تحرير أوجه القصور',
  'Edit History': 'تحرير التاريخ',
  'Edit Location': 'تحرير الموقع',
  'Edit Schedule': 'تحرير الجدول الزمني',
  'Edit Service': 'تحرير الخدمة',
  'Edit Settings': 'تحرير الإعدادات',
  'End Time': 'وقت النهاية',
  'Equal to': 'يساوي',
  'Equipment Field': 'مجال المعدات',
  'Equipment replaced': 'تم استبدال المعدات',
  'Equipment swapped': 'تم تبديل المعدات',
  'Example: Broken Handle': 'مثال: المقبض المكسور',
  'Frequency Type': 'نوع التردد',
  'Generate Reports': 'إنشاء التقارير',
  'Get started by checking out our tutorials on YouTube or setting up your account in settings.': 'ابدأ بالاطلاع على برامجنا التعليمية على YouTube أو قم بإعداد حسابك في الإعدادات.',
  'Global Search': 'البحث العالمي',
  'Greater than': 'أعظم من',
  'hasn&apos;t accepted their invite yet. You can': 'لم يقبل دعوتهم بعد. ',
  'Include In Reports': 'تضمين في التقارير',
  'landscape LetterHead': 'المناظر الطبيعية، ترويسة',
  'Last Date': 'التاريخ الأخير',
  'Last Date Minimum Granularity': 'التاريخ الأخير الحد الأدنى من التفاصيل',
  'Last Download': 'آخر تنزيل',
  'Last Upload': 'آخر تحميل',
  'Less than': 'أقل من',
  'Locations can only be added on a desktop browser': 'لا يمكن إضافة المواقع إلا على متصفح سطح المكتب',
  'Looks like you never finished signing up': 'يبدو أنك لم تنتهِ من الاشتراك مطلقًا',
  'Metered Condition': 'حالة المقاسة',
  'Mobile Access': 'الوصول عبر الهاتف المحمول',
  'Model Number': 'رقم الموديل',
  'Next Date (Overide)': 'التاريخ التالي (تجاوز)',
  'No Conditions': 'لا توجد شروط',
  'No Options': 'لا توجد خيارات',
  'Not equal to': 'لا يساوي',
  'Opened Date': 'تاريخ الفتح',
  'Option Selected': 'تم تحديد الخيار',
  'Perform On Scan': 'تنفيذ على المسح الضوئي',
  'Please click the button below to start your free 3 month trial': 'الرجاء الضغط على الزر أدناه لبدء النسخة التجريبية المجانية لمدة 3 أشهر',
  'Please review the terms below': 'يرجى مراجعة الشروط أدناه',
  'Portrait LetterHead': 'صورة ذات رأسية',
  'Postal Code': 'رمز بريدي',
  'Powered By': 'مدعوم من',
  'Preventive Maintenance': 'الصيانة الوقائية',
  'Profile Image': 'صورة الملف الشخصي',
  'Receive marketing emails': 'تلقي رسائل البريد الإلكتروني التسويقية',
  'Rivison Inc.': 'شركة ريفيسون',
  'Search Sites...': 'مواقع البحث...',
  'Serial Number': 'رقم سري',
  'Service is Unscheduled': 'الخدمة غير مجدولة',
  'Service Options': 'خيارات الخدمة',
  'Service or Inspection Due': 'الخدمة أو التفتيش المستحق',
  'Show All': 'إظهار الكل',
  'Show site selector in top corner': 'إظهار محدد الموقع في الزاوية العليا',
  'Sign-Up Failed. Ensure the email is not already is use.': 'فشل التسجيل. ',
  'Sorry, an error occurred while trying to create an invite link. Please try again later, or reach out to support': 'عذرًا، حدث خطأ أثناء محاولة إنشاء رابط دعوة. ',
  'Sorry, looks like you&apos;re offline. Please try again when you have an internet connection': 'عذرًا، يبدو أنك غير متصل بالإنترنت. ',
  'Start Time': 'وقت البدء',
  'Successfully updated profile': 'تم تحديث الملف الشخصي بنجاح',
  'terms and conditions': 'الشروط والأحكام',
  'Text Input': 'إدخال النص',
  'The date below is used to show history records only.': 'يتم استخدام التاريخ أدناه لإظهار سجلات التاريخ فقط.',
  'This will just take a moment': 'هذا سوف يستغرق لحظة واحدة فقط',
  'Time Condition': 'حالة الوقت',
  'Time Zone': 'المنطقة الزمنية',
  'to generate another invite link.': 'لإنشاء رابط دعوة آخر.',
  'Toggle Flashlight': 'تبديل المصباح',
  'Type more characters to narrow the search further': 'اكتب المزيد من الأحرف لتضييق نطاق البحث بشكل أكبر',
  'Use text answer for': 'استخدم الإجابة النصية لـ',
  'Version:': 'إصدار:',
  'View Deficiencies': 'عرض أوجه القصور',
  'View Equipment': 'عرض المعدات',
  'View History': 'عرض التاريخ',
  'View Location': 'عرض الموقع',
  'View Schedule': 'عرض الجدول الزمني',
  'View Service': 'عرض الخدمة',
  'View Settings': 'عرض الإعدادات',
  'We hope to see you again.': 'نأمل أن نراكم مرة أخرى.',
  'Web Login': 'تسجيل الدخول على شبكة الإنترنت',
  'Welcome,': 'مرحباً،',
  'White Label': 'العلامة البيضاء',
  'Work Day End Time': 'وقت انتهاء يوم العمل',
  'Work Day Start Time': 'وقت بدء يوم العمل',
  'You must agree to the terms and conditions': 'يجب عليك الموافقة على الشروط والأحكام',
  'Your Subscription Has Been Canceled': 'لقد تم إلغاء اشتراكك',
};
